import React from 'react';
import PropTypes from 'prop-types';
import { useStaticQuery, graphql } from 'gatsby';
import { MdArrowDropDown } from 'react-icons/md';
import {
  SinglePageContainer, SectionLink, ChildList, ChildLink,
} from './header-single-pages-css';

const HeaderSinglePagesWrapper = ({ singlePages }) => {
  if (!singlePages || singlePages.length === 0) return null;

  const firstPage = singlePages[0];
  const otherPages = singlePages.slice(1);
  return (
    <SinglePageContainer>
      <SectionLink to={`${firstPage.slug}`}>
        {firstPage.title}
        {otherPages.length > 0 && <MdArrowDropDown size="26px" />}
      </SectionLink>
      {otherPages.length > 0 && (
        <ChildList>
          {otherPages.map(({ title, slug }) => (
            <li key={slug}>
              <ChildLink to={`/${slug}`}>{title}</ChildLink>
            </li>
          ))}
        </ChildList>
      )}
    </SinglePageContainer>
  );
};

HeaderSinglePagesWrapper.propTypes = {
  singlePages: PropTypes.arrayOf(PropTypes.shape({
    title: PropTypes.string.isRequired,
    slug: PropTypes.string.isRequired,
  })),
};

HeaderSinglePagesWrapper.defaultProps = {
  singlePages: null,
};

const HeaderSinglePagesWrapperWithQuery = (props) => {
  const { contentfulNavigation } = useStaticQuery(graphql`
    query {
      contentfulNavigation(title: {eq: "Header single pages"}) {
        links {
          title
          slug
        }
      }
    }
  `);

  return (
    <HeaderSinglePagesWrapper
      singlePages={contentfulNavigation ? contentfulNavigation.links : null}
      {...props}
    />
  );
};

export default HeaderSinglePagesWrapperWithQuery;
